module.exports = __webpack_public_path__ + "static/media/18.27dab5b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/18.png
// module id = 1348
// module chunks = 0